import { f as functionUncurryThis, g as globalThis_1 } from './classof-d5e7087e.js';

var entryUnbind = function (CONSTRUCTOR, METHOD) {
  return functionUncurryThis(globalThis_1[CONSTRUCTOR].prototype[METHOD]);
};

export { entryUnbind as e };
